import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, ProgressBar } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";



import { useForm } from 'react-hook-form';

import svgWait1 from './svg/wait1.svg'
import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import { SystemHeader, ClientPicker } from './CommonUI';

interface Account {
    d_acCode: string,
    d_acName1: string,
    d_acName2: string,
}

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

interface PageInfo {
    n: number
}

var GsbFlag: any;


interface StkHoldList_StressTestMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function StkHoldList_StressTestMain({ gsb }: StkHoldList_StressTestMainProps) {

    let ProgressId2 = ""
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
        
    const [AcCodeList, setAcCodeList] = useState([] as Account[])

    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [ShowWait, setShowWait] = useState(false)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)

 
    const [s_sortby, sets_sortby] = useState("S")
    const [s_StkNo1, sets_StkNo1] = useState("")
    const [s_StkNo2, sets_StkNo2] = useState("")
    const [s_ClCode1, sets_ClCode1] = useState("")
    const [s_ClCode2, sets_ClCode2] = useState("")
    const [s_Runner1, sets_Runner1] = useState("")
    const [s_Runner2, sets_Runner2] = useState("")
    const [s_Branch1, sets_Branch1] = useState("")
    const [s_Branch2, sets_Branch2] = useState("")
    const [setClCodeValue, setSetClCodeValue] = useState(() => sets_ClCode1)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [Caretdown1, setCaretdown1] = useState(false)
    const [Caretdown2, setCaretdown2] = useState(false)
    const [s_PrintDetail, sets_PrintDetail] = useState("D")

    const [s_PrintStockType, sets_PrintStockType] = useState("A")   // 20230620
    const [s_PrintClientType, sets_PrintClientType] = useState("A")   // 20230620

    const [DataFormatValue, setDataFormatValue] = useState(false)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    //const [cPrintMode, setcPrintMode] = useState("PS")
    const [MoblieDev, setMoblieDev] = useState(false)

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("DEMO")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [showMU_BRANCH, setshowMU_BRANCH] = useState(false)
    const [showTBOB_USER, setshowTBOB_USER] = useState(false)


    //alert(navigator.userAgent)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key)
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setCSVFormat(GsbFlag.CSVFormat) ;

                setshowMU_BRANCH(GsbFlag.MU_BRANCH) ;
                setshowTBOB_USER(GsbFlag.TBOB_USER) ;
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    

    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])


    useEffect(() => {
        (async () => {
            try {
                // get AC List
                const res = await gsb.post('/Master',
                {   sb_data: {
                    by: "acCode",
                    start: "",
                    nPage: 1,
                    limit: 0,
                    backward: false,
                    SortByName: true
                },
                cPgmId: "Clmast",
                cAction: "ListRec",
            });

                //console.log("res.data.data: ", res.data.data) 
                //setAcCodeList(utils.sortByColumn(res.data.data, "d_acName1"))
                setAcCodeList(res.data.data)
                //console.log("set AcCodeList: ", AcCodeList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if ( userKey == "COMPSHARE" ) {
            setDataFormatValue(true)
        }
        if ( showTBOB_USER && s_PrintDetail === "S" ) {
            sets_PrintClientType("NB")
        }
    }, [gsb, GsbFlag, userKey, showTBOB_USER, s_PrintDetail])


    const acRenderer: ItemRenderer<Account> = (ac, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${ac.d_acName1}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={ac.d_acCode}
                key={ac.d_acCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const acPredicate: ItemPredicate<Account> = (query, ac, _index, exactMatch) => {
        const normalizedText = `${ac.d_acCode} - ${ac.d_acName1}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const acValueRenderer = (ac: Account) => {
        return ac.d_acCode
    }


    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }


    useEffect(() => {
        setRptName("")
        setShowRpt(false)
        setShowNoRecord(false)
        setShowOK(true)
    }, [s_sortby, s_StkNo1, s_StkNo2, s_ClCode1, s_ClCode2, s_Runner1, s_Runner2, s_Branch1, s_Branch2, s_PrintDetail, s_PrintStockType, s_PrintClientType, DataFormatValue])

    useEffect(() => {
        if ( RptName !== "" && DataFormatValue ) {
            document.getElementById("_rptlink")?.click()
        }
    }, [RptName]) 

    useEffect(() => {
        const refreshTasks = async () => {
            ProgressId2 = ProgressId
            //console.log("Progresslist ProgressId: ", ProgressId2)
            if ( ProgressId2.trim().length > 0 ) {
                try {
                    const res = await gsb.post('/Progresslist', {p_data: ProgressId2})
                    let pValue = 0
                    if ( res.data.count > 0 ) {
                        if ( res.data.data[0].id === ProgressId2 ) {
                            pValue = res.data.data[0].progressValue / res.data.data[0].progressMax
                            //console.log("Progresslist: ", res.data.data[0].progressValue, res.data.data[0].progressMax) 
                            //console.log("Progresslist pValue: ", pValue) 
                            setProgressValue(pValue)
                        }
                        if (res.data.data[0].status > 0 ) {
                            clearInterval(timer)
                        }
                    }
                } catch (error) {
                    utils.showError(error)
                }
            }
        }
        let timer = setInterval(refreshTasks, 20*1000)
        return () => {clearInterval(timer)}
    }, [gsb, ProgressId, nPage])


    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        sets_ClCode1(s_ClCode1.toUpperCase());
        sets_ClCode2(s_ClCode2.toUpperCase());
        sets_Runner1(s_Runner1.toUpperCase());
        sets_Runner2(s_Runner2.toUpperCase());

        setShowOK(false)
        setShowWait(true)
        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")
        setRptNameNo(0)
        setnPage(1)
        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)
        //console.log("StkHoldMain onsubmit ProgressId: ", ProgressId2) 

        if ( utils.getDeviceType()) {
            //alert("MoblieDev")
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
    
        (async () => {
            try {
                //console.log("SmMastMain onsubmit called", data)
                const res = await gsb.post('/Report',
                    {   sb_data: {
                            ProgressId: ProgressId2,
                            s_sortby: s_sortby,
                            s_StkNo1: s_StkNo1,
                            s_StkNo2: s_StkNo2,
                            s_ClCode1: s_ClCode1,
                            s_ClCode2: s_ClCode2,
                            s_Runner1: s_Runner1,
                            s_Runner2: s_Runner2,
                            s_Branch1: s_Branch1,
                            s_Branch2: s_Branch2,
                            s_PrintDetail: s_PrintDetail,
                            s_PrintStockType: s_PrintStockType,      // 20230620
                            s_PrintClientType: s_PrintClientType,    // 20230620
                            DataFormat: DataFormatValue,
                            Stk_OD: false,
                            nPage: 1,
                            cPrintMode: "PS",
                        },
                        cPgmId: "StkHoldList_StressTest",
                    });

                //console.log("res.data.data: ", res.data.data) 
                if ( res.data.count > 0 ) {
                    setRstdata2([])
                    for (let j = 0; j < res.data.Rptdata.length; j++) {
                        Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                    }
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)
                    setRstdata(Rstdata2)
                    console.log("Rstdata: ", Rstdata) 
                    setRptHead1(res.data.Rpthead1)
                    setRptName(res.data.RptName)
                    setRptNameNo(res.data.RptNameNo)
                    //console.log("RptName: ", RptName) 
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(res.data.TotalPageNo)
                        for ( let j = 1; j <= res.data.TotalPageNo; j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRpt(false)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }


    //Press page No 1 2 3 4
    useEffect(() => {
        if (nPage > 0 && nPage <= nTotalPage && RptName.trim().length > 0) {
            // console.log("calling API for Pagination");
            setShowWait(true)
            setShowNoRecord(false)
            setShowRpt(false)
            setRstdata([])
    
            ProgressId2 = utils.genUUID()
            setProgressId(ProgressId2)
            setProgressValue(0)
            //console.log("StkHoldMain useEffect ProgressId: ", ProgressId2) 

            ;
    
            (async () => {
                try {
                    //console.log("StkHoldMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Report',
                    {   sb_data: {
                            ProgressId: ProgressId2,
                            s_sortby: s_sortby,
                            s_StkNo1: s_StkNo1,
                            s_StkNo2: s_StkNo2,
                            s_ClCode1: s_ClCode1,
                            s_ClCode2: s_ClCode2,
                            s_Runner1: s_Runner1,
                            s_Runner2: s_Runner2,
                            s_Branch1: s_Branch1,
                            s_Branch2: s_Branch2,
                            s_PrintDetail: s_PrintDetail,
                            s_PrintStockType: s_PrintStockType,      // 20230620
                            s_PrintClientType: s_PrintClientType,    // 20230620
                            s_RptName: RptName,
                            DataFormat: DataFormatValue,
                            Stk_OD: false,
                            nPage: nPage,
                            cPrintMode: "S",
                        },
                        cPgmId: "StkHoldList_StressTest",
                    });

                    //console.log("res.data.data: ", res.data.data) 
                    if ( res.data.count > 0 ) {
                        setRstdata2([])
                        for (let j = 0; j < res.data.Rptdata.length; j++) {
                            Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                        }
                        setRptHead1(res.data.Rpthead1)
                        setShowWait(false)
                        setShowNoRecord(false)
                        setShowRpt(true)
                        setRstdata(Rstdata2)
                        //console.log("Rstdata: ", Rstdata) 
                    } else {
                        setShowWait(false)
                        setShowNoRecord(true)
                        setShowRpt(false)
                    }
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let RptNameaRef = <>
        { RptNameNo > 0 && <div> Download / Print &nbsp;
            {aRptNameNo.map((no, j) => 
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
            )}
        </div> }
        { RptNameNo <= 0 && <a id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>}
    </>

    let list = <>
        <div className="Spacing-V-8" />
        {/* {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>} */}
        {RptName.trim().length > 0 && RptNameaRef}
        {ShowRpt && ! DataFormatValue && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead id="rpt_th_r">
                <tr >
                    { ! DataFormatValue && <th className="RCol-Head_p">
                        {/* {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print</a>} */}
                        {RptName.trim().length > 0 && RptNameaRef}
                    </th>
                    }
                </tr>                    
                <tr>
                    <td className="RCol-Head1">{RptHead1}</td>
                </tr>                    
            </thead>
            <tbody id="rpt_tr">
                {Rstdata.map((rpt, i) =>
                    <tr key={i} onDoubleClick={() => { {rpt.Rst_Key.trim().length > 0 && window.open(`/#/ClientPosEnquiry?acCode=${rpt.Rst_Key}`, '_blank') } } }>
                        <td className="RCol-Rpt" onClick={() => { MoblieDev && rpt.Rst_Key.trim().length > 0 && window.open(`/#/ClientPosEnquiry?acCode=${rpt.Rst_Key}`, '_blank') } }>{rpt.Rst_Line}</td>
                    </tr>
                )}
            </tbody>
            <div className="Spacing-V-16" />
            {ShowRpt && ! DataFormatValue && Pagination}
        </HTMLTable>
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    
    return (
        <>
            <ClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setClCodeValue(ac.d_acCode); setIsClPickerOpen(false)}}/>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>74 Stock Holder List  *** STOCK MARKET VALUE STRESS TEST ***</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        Sort by
                        <FormGroup className="Col-2-6" label="">
                            <RadioGroup
                                inline={true}
                                selectedValue={s_sortby}
                                onChange={utils.handleStringChange(s => sets_sortby(s))  }
                            >
                                <Radio label="Stock No." value="S" />
                                <Radio label="Account No."  value="A" />
                                <Radio label="Runner"  value="R" />
                                {showMU_BRANCH && <Radio label="Location"  value="B" /> }

                            </RadioGroup>
                        </FormGroup>
                    </div>
                    { s_sortby == "S" &&
                        <div className="Row">
                            <FormGroup className="Col-1-2" label="Start Stock No." labelFor="inputStkNo1" >
                                <InputGroup
                                    id="inputStkNo1"
                                    autoFocus
                                    placeholder="Stock No ..."
                                    value={s_StkNo1}
                                    onChange={utils.handleStringChange(s => sets_StkNo1(s)) }
                                />
                            </FormGroup>
                            <FormGroup className="Col-4-2" label="Stock No." labelFor="inputStkNo1">
                                <InputGroup
                                    id="inputStkNo1"
                                    placeholder="Stock No ..."
                                    value={s_StkNo2}
                                    onChange={utils.handleStringChange(s => sets_StkNo2(s))}
                                />
                            </FormGroup>
                        </div>
                    }
                    { s_sortby == "A" &&
                        <div className="Row">
                            { ! Caretdown1 && 
                                <FormGroup className="Col2-1-2" label="Start Account No." labelFor="inputClCode1" >
                                    <InputGroup 
                                        className="inputClCode"
                                        id="inputClCode1"
                                        autoFocus
                                        placeholder=" Account No. ..."
                                        value={s_ClCode1}
                                        onChange={utils.handleStringChange(s => sets_ClCode1(s))}
                                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setSetClCodeValue(()=>sets_ClCode1); setIsClPickerOpen(true)}}></Button>}
                                        />
                                </FormGroup>
                            }
                            {/* rightElement={<Button icon="chevron-down" minimal onClick={() => {setSetClCodeValue(()=>sets_ClCode1); setIsClPickerOpen(true)}}></Button>} */}
                            { Caretdown1 && 
                                <FormGroup className="Col3-1-2" label="Start Account No." labelFor="inputClCode1" >
                                    <Suggest
                                        inputProps={{ placeholder: "Please choose Account No. ..." }}
                                        defaultSelectedItem={AcCodeList.find((ac1) => ac1.d_acCode === s_ClCode1)}
                                        items={AcCodeList}
                                        itemRenderer={acRenderer}
                                        itemPredicate={acPredicate}
                                        inputValueRenderer={acValueRenderer}
                                        onItemSelect={(ac) => { sets_ClCode1(ac.d_acCode) ; setCaretdown1(!Caretdown1) }}
                                    />
                                </FormGroup>
                            }
                            {/* <span onClick={() => { setCaretdown1(!Caretdown1) } }> {imgCaretdown} </span> */}
                            { ! Caretdown2 && 
                                <FormGroup className="Col2-4-2" label="Account No." labelFor="inputClCode2">
                                    <InputGroup
                                        className="inputClCode"
                                        id="inputClCode2"
                                        placeholder=" Account No. ..."
                                        value={s_ClCode2}
                                        onChange={utils.handleStringChange(s => sets_ClCode2(s))}
                                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setSetClCodeValue(()=>sets_ClCode2); setIsClPickerOpen(true)}}></Button>}
                                        />
                                </FormGroup>
                            }
                            { Caretdown2 && 
                                <FormGroup className="Col3-4-2" label="Account No." labelFor="inputClCode2" >
                                    <Suggest
                                        inputProps={{ placeholder: "Please choose Account No. ..." }}
                                        defaultSelectedItem={AcCodeList.find((ac2) => ac2.d_acCode === s_ClCode2)}
                                        items={AcCodeList}
                                        itemRenderer={acRenderer}
                                        itemPredicate={acPredicate}
                                        inputValueRenderer={acValueRenderer}
                                        onItemSelect={(ac) => { sets_ClCode2(ac.d_acCode) ; setCaretdown2(!Caretdown2) }}
                                    />
                                </FormGroup>
                            }
                            {/* <span onClick={() => { setCaretdown2(!Caretdown2) } }> {imgCaretdown} </span> */}
                        </div>
                    }
                    { s_sortby == "R" &&
                        <div className="Row">
                            <FormGroup className="Col-1-2" label="Start Runner No." labelFor="inputRunner1" >
                                <InputGroup
                                    id="inputRunner1"
                                    autoFocus
                                    placeholder="Runner No ..."
                                    value={s_Runner1}
                                    onChange={utils.handleStringChange(s => sets_Runner1(s)) }
                                />
                            </FormGroup>
                            <FormGroup className="Col-4-2" label="Runner No." labelFor="inputRunner2">
                                <InputGroup
                                    id="inputRunner2"
                                    placeholder="Runner No ..."
                                    value={s_Runner2}
                                    onChange={utils.handleStringChange(s => sets_Runner2(s))}
                                />
                            </FormGroup>
                        </div>
                    }
                    { s_sortby == "B" &&
                        <div className="Row">
                            <FormGroup className="Col-1-2" label="Start Location" labelFor="inputBranch1" >
                                <InputGroup
                                    id="inputBranch"
                                    autoFocus
                                    placeholder="Location ..."
                                    value={s_Branch1}
                                    onChange={utils.handleStringChange(s => sets_Branch1(s)) }
                                />
                            </FormGroup>
                            <FormGroup className="Col-4-2" label="Location" labelFor="inputBranch2">
                                <InputGroup
                                    id="inputBranch2"
                                    placeholder="Location ..."
                                    value={s_Branch2}
                                    onChange={utils.handleStringChange(s => sets_Branch2(s)) }
                                />
                            </FormGroup>
                        </div>
                    }
                    { (s_sortby == "S" || s_sortby == "A" ) && showMU_BRANCH &&
                        <div className="Row">
                            <FormGroup className="Col-1-2" label="Location" labelFor="inputBranch1" >
                                <InputGroup
                                    id="inputBranch"
                                    placeholder="Location ..."
                                    value={s_Branch1}
                                    onChange={utils.handleStringChange(s => sets_Branch1(s)) }
                                />
                            </FormGroup>
                        </div>
                    }
                    { ( s_sortby == "S" || s_sortby == "A" ) && <FormGroup className="Col-1-2" label="">
                        <RadioGroup
                            inline={true}
                            selectedValue={s_PrintDetail}
                            onChange={utils.handleStringChange(s => sets_PrintDetail(s))  }
                        >
                            <Radio label="Detail"  value="D" />
                            <Radio label="Summary"  value="S" />
                        </RadioGroup>
                    </FormGroup> }
                    {/* 20230620 */}
                    <FormGroup className="Col-1-5" label="">
                        <RadioGroup
                            inline={true}
                            selectedValue={s_PrintStockType}
                            onChange={utils.handleStringChange(s => sets_PrintStockType(s))  }
                        >
                            <Radio label="Show All Stocks"  value="A"/>
                            <Radio label="Show CCASS Stocks Only"  value="C"/>
                            <Radio label="Show NON-CCASS Stocks Only"  value="N"/>
                        </RadioGroup>
                    </FormGroup> 
                    {/* 20230620 */}
                    <FormGroup className="Col-1-5" label="">
                        <RadioGroup
                            inline={true}
                            selectedValue={s_PrintClientType}
                            onChange={utils.handleStringChange(s => sets_PrintClientType(s))  }
                        >
                            <Radio label="Show All Clients"  value="A"/>
                            <Radio label="Show Margin Clients Only"  value="M"/>
                            <Radio label="Show Cash Clients Only"  value="C"/>
                            <Radio label="Show Broker Clients Only"  value="B"/>
                            <Radio label="Show Debit Bal Margin Clients Only"  value="N"/>
                            <Radio label="Show Credit & Zero Bal Margin Clients Only"  value="Z"/>
                            { showTBOB_USER && <Radio label="Show All Clients Except Broker"  value="NB"/> }
                        </RadioGroup>
                    </FormGroup> 
                    <FormGroup className="Col-1-2" label="">
                        <RadioGroup
                            inline={true}
                            selectedValue={DataFormatValue? "D": "P"}
                            onChange={utils.handleStringChange(s => setDataFormatValue(s == "D"))  }
                        >
                            <Radio label="PDF Format"  value="P" />
                            { (CSVFormat === "1") && <Radio label="DATA Format (EXCEL, CSV)" value="D" /> }
                            { ! (CSVFormat === "1") && <Radio label="DATA Format (EXCEL, TAB)" value="D" /> }
                        </RadioGroup>
                    </FormGroup>
                    <div className="Row">
                        <Button disabled={! ShowOK} type="submit">OK</Button>
                    </div>
                </Card>
                {/* {ShowWait && <div>{imgWait}</div> } */}
                {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div> }
                {ShowNoRecord && <p>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-3"  >
                            <span id="Err_msg">No Record found !!!</span>
                        </FormGroup>
                    </div>
                </p>
                }
                {ShowRpt && list}
            </form>
        </>
    );
}

export default StkHoldList_StressTestMain